import { createApi } from "@reduxjs/toolkit/query/react";

import { baseQuery } from "@tsp-core/store/utils";

import { PositionsDictionary, PositionsDictionaryRecord } from "../types";

type GetPositionsResponseData = Array<PositionsDictionaryRecord>;

export const positionsApi = createApi({
  reducerPath: "@positions/api",
  baseQuery,
  refetchOnFocus: false,
  refetchOnReconnect: false,
  refetchOnMountOrArgChange: false,
  keepUnusedDataFor: 60 * 60 * 24,
  endpoints: (builder) => ({
    getPositionsDictionary: builder.query<PositionsDictionary, void>({
      query: () => ({
        url: "/getPositions",
        method: "POST",
      }),
      transformResponse: (response: GetPositionsResponseData) => {
        return response.reduce((accumulator, item) => {
          const name = item.name || "No name";
          const postfix = item.isArchived ? " (Archived)" : "";

          accumulator[item.uuid] = {
            uuid: item.uuid,
            name: `${name}${postfix}`,
            isArchived: item.isArchived,
          };
          return accumulator;
        }, {} as PositionsDictionary);
      },
    }),
  }),
});
